import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { Component, OnInit, Input } from '@angular/core';
import { Helper } from '../../../shared/helper';
import { Logger } from 'app/shared';
import { Chart } from 'chart.js';

@Component({
  selector: 'htm-multi-legend',
  templateUrl: './multi-legend.component.html',
  styleUrls: ['./multi-legend.component.scss']
})
export class MultiLegendComponent implements OnInit, OnChanges {
  @Input() chart;
  @Input() chart_id;
  private _legends = [];
  private donut_to_bar = false;
  constructor(private logger: Logger, private helper: Helper) { }
  get legends() {return this._legends}
  ngOnInit() {
    this.logger.log('MultiLegendComponent/ngOnInit()');
    if (['renewable_bar', 'renewable_bar_energy_absolute', 'renewable_bar_energy_pourcent', 'local_bar', 'mix_bar'].includes(this.chart_id )){
      this.donut_to_bar = true;
    }
  }

  ngOnChanges(changes) {
    if (!this.helper.isNullOrUndefined(this.chart)) {
      this.update();
    }
  }

  update() {
    const self = this
    const setData = new Set();
    self._legends = []

    this.chart.config.data.datasets.forEach(function (dataset, index) {
      var meta = self.chart.controller.getDatasetMeta(index);
      meta.data.forEach(function(bar) {
        let model = bar._model;
        let label = dataset.stack;
        if ((label !== undefined) && (!setData.has(model.label + ';' + label))) {
          const tmp = { x: model.x, label: label, width: model.width }
          self.legends.push(tmp)
          setData.add(model.label + ';' + label )
        }
      });
    });
  }
}
